"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandBase = void 0;
const uuid_1 = require("uuid");
const globalOptions_1 = require("../globalOptions");
class CommandBase {
    constructor(name, body) {
        if (!name) {
            throw new Error("name cannot be null or white space");
        }
        this.name = name;
        this.bodyObject = body;
        if (globalOptions_1.CommandsGlobalOptions.AutoGenerateCommandId) {
            this.bodyObject.commandId = this.bodyObject.commandId || (0, uuid_1.v4)();
        }
        const isMessagePriorityInvalid = !Number.isInteger(this.bodyObject.messagePriority);
        if (globalOptions_1.CommandsGlobalOptions.DefaultInvalidMessagePriorityTo1 &&
            isMessagePriorityInvalid) {
            this.bodyObject.messagePriority = 1;
        }
    }
}
exports.CommandBase = CommandBase;
//# sourceMappingURL=interfaces.js.map